import * as React from "react";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";

import { DeviceFraudStatusIcon } from "app/components/AppComponents/Fraud";

import DatePicker from "material-ui/DatePicker";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";

import * as moment from "moment-timezone";

// JQUERY
import * as $ from "jquery";

// AUTH
import oktaClient from "app/utils/oktaClient";

import { susCardLoadsList } from "./Fraud.SusCardLoadsList.Query";

let OFFSET = 0;
let LIMIT = 30;

class SuspiciousDevices extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    // SETS DEAULT TO PREVIOUS DAY
    const filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);
    // TO USE SET filter_date: filterDate IN STATE

    this.state = {
      data: null,
      loading: false,
      limit: LIMIT,
      offset: OFFSET,
      filter_date: this.props.savedStates["ss_fraud_sus_card_loads"]
        ? this.props.savedStates["ss_fraud_sus_card_loads"].filter_date
        : filterDate,
      selectedRows: [],
      shiftKey: false,
      lastItem: null,
    };

    this.loadData = this.loadData.bind(this);

    //  PAGINATION
    this.loadNext = this.loadNext.bind(this);
    this.loadPrev = this.loadPrev.bind(this);

    //  FILTERING
    this.changeDate = this.changeDate.bind(this);

    this.handleGroupStatus = this.handleGroupStatus.bind(this);
    this.runUpdate = this.runUpdate.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.checkRows = this.checkRows.bind(this);
    this.selectRow = this.selectRow.bind(this);
  }

  componentDidMount() {
    const thiss = this;
    document
      .getElementById("setHeight")
      .addEventListener("scroll", function () {
        var translate = "translate(0," + this.scrollTop + "px)";
        this.querySelector("thead").style.transform = translate;
      });
    $(document).on("keyup keydown", function (e: any) {
      thiss.setState({ shiftKey: e.shiftKey });
    });
    this.loadData(
      this.props.savedStates["ss_fraud_sus_card_loads"]
        ? this.props.savedStates["ss_fraud_sus_card_loads"].filter_date
        : this.state.filter_date,
      this.props.savedStates["ss_fraud_sus_card_loads"]
        ? this.props.savedStates["ss_fraud_sus_card_loads"].offset
        : this.state.offset
    );
    this.props.setHeader({
      title: "Fraud > Suspicious Card Loads",
      description: "Suspicious SnapScan card loads",
    });
  }

  componentWillUnmount() {
    $(document).off("keyup keydown");
  }

  loadData(getFilter: any, getOffset: any) {
    this.props.addToStates("ss_fraud_sus_card_loads", {
      filter_date: getFilter,
      offset: getOffset,
    });
    this.setState({
      loading: true,
      data: null,
      filter_date: getFilter,
      offset: getOffset,
    });
    let createdAtFrom = null;
    let createdAtTo = null;

    if (getFilter !== null) {
      const setDateFrom = moment(getFilter)
        .startOf("day")
        .tz("Africa/Johannesburg")
        .format();
      const setDateTo = moment(getFilter)
        .endOf("day")
        .tz("Africa/Johannesburg")
        .format();
      createdAtFrom = setDateFrom;
      createdAtTo = setDateTo;
    }

    this.props.data.fetchMore({
      variables: {
        from: createdAtFrom,
        to: createdAtTo,
        offset: getOffset,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.fraud, loading: false });
      },
    });
  }

  loadNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadData(this.state.filter_date, TMP_OFFSET);
  }
  loadPrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadData(this.state.filter_date, TMP_OFFSET);
  }

  changeDate(event: any, date: any) {
    this.loadData(date, 0);
  }

  handleGroupStatus(e: any, key: any, status: any) {
    var token = oktaClient.getToken();
    const comment = "Updated by " + token.claims.email;
    var data = [];
    this.state.data.devices_with_suspicious_card_loads.map((item, i) => {
      return this.state.selectedRows.map((value, keyRow) => {
        if (parseInt(value, 10) === i) {
          var temp = [];
          temp["external_ref"] = item.devices[0].external_reference;
          temp["comment"] = comment;
          temp["status"] = status;

          data.push(temp);
        }
        return "1";
      });
    });
    this.runUpdate(data, this.state);
  }

  runUpdate(data: any, state: any) {
    const thiss = this;
    data.map((value, key) => {
      $.ajax({
        type: "POST",
        url:
          process.env["REACT_APP_" + process.env.REACT_APP_ENV + "_LINK"] +
          "/integration/console/fraud/device/fraud_status",
        data: {
          external_reference: value["external_ref"],
          comment: value["comment"],
          status: value["status"],
        },
        headers: {
          Authorization: oktaClient.getAuthorizationHeader(),
          "x-User-Groups": ["snapscan", "wechat", "masterpass"],
        },
      }).done(function () {
        thiss.loadData(state.filter_date, state.offset);
        thiss.setState({ selectedRows: [] });
      });
      return "1";
    });
  }

  checkRows() {
    const tmpArr = [];
    $(".itemSelect").map(function (key: any, val: any) {
      if ($(val).is(":checked")) {
        tmpArr.push(val.value);
      }

      return "1";
    });
    this.setState({ selectedRows: tmpArr });
  }

  toggleAll(e: any) {
    if ($(e.target).is(":checked")) {
      $(".itemSelect").prop("checked", true);
    } else {
      $(".itemSelect").prop("checked", false);
    }
    this.checkRows();
  }

  selectRow(e: any) {
    const value = $(e.target).val();
    if (this.state.shiftKey) {
      if (this.state.selectedRows.length > 0) {
        const lastItem = this.state.lastItem;
        if (parseInt(value, 10) > parseInt(lastItem, 10)) {
          $(".itemSelect").map(function (key: any, val: any) {
            if (
              parseInt($(val).val(), 10) > parseInt(lastItem, 10) &&
              parseInt($(val).val(), 10) < parseInt(value, 10)
            ) {
              $(val).prop("checked", true);
            }

            return "1";
          });
        } else {
          $(".itemSelect").map(function (key: any, val: any) {
            if (
              parseInt($(val).val(), 10) < parseInt(lastItem, 10) &&
              parseInt($(val).val(), 10) > parseInt(value, 10)
            ) {
              $(val).prop("checked", true);
            }

            return "1";
          });
        }
      } else {
        this.setState({ lastItem: value });
      }
    } else {
      this.setState({ lastItem: value });
    }
    this.checkRows();
  }

  render() {
    const topDevicesList = this.state.data
      ? this.state.data.devices_with_suspicious_card_loads
      : [];

    const devices = (allDevices) => {
      const count = Object.keys(allDevices).length;
      return (
        <div>
          {count} - <DeviceFraudStatusIcon device={allDevices[0]} />
        </div>
      );
    };

    const merchants = (topMerchants) => {
      return topMerchants.map((merchant, mi) => {
        return (
          <div key={mi}>
            <Link
              className="blueLink"
              to={`/snapscan/ops/merchants/${merchant.id}/payments`}
            >
              {" "}
              {merchant.name}{" "}
            </Link>
            {" - "}
            <Link
              className="blueLink"
              to={`/snapscan/fraud/merchant_limit_configs/${merchant.merchant.merchant_limit_configuration.name}/summary`}
            >
              {merchant.merchant.merchant_limit_configuration.name}
            </Link>
          </div>
        );
      });
    };

    const users = (allUsers) => {
      return allUsers.map((user, ui) => {
        return (
          <div key={ui}>
            <Link
              className="blueLink"
              to={`/snapscan/ops/users/${user.external_reference}/payments`}
            >
              {" "}
              {user.email}{" "}
            </Link>
            <a
              style={{ marginLeft: "6px" }}
              target="_blank"
              rel="noopener noreferrer"
              className="blueLink"
              href={user.snapmin_url}
            >
              <i className="fa fa-info-circle" />
            </a>
          </div>
        );
      });
    };

    const cardLoads = (allCardLoads) => {
      return allCardLoads.map((card, ci) => {
        return (
          <span key={ci}>
            <Link
              className="blueLink"
              to={`/snapscan/ops/card_loads/${card.external_reference}/summary`}
            >
              {" "}
              {card.country_code}{" "}
            </Link>
            <a
              style={{ marginLeft: "6px" }}
              target="_blank"
              rel="noopener noreferrer"
              className="blueLink"
              href={card.snapmin_url}
            >
              <i className="fa fa-info-circle" />
            </a>
          </span>
        );
      });
    };

    const showData = () => {
      if (topDevicesList.length > 0) {
        return topDevicesList.map((item, i) => {
          return (
            <tr style={{ height: "30px" }} key={i}>
              <td>
                <input
                  type="checkbox"
                  value={i}
                  className="itemSelect"
                  onClick={this.selectRow}
                />
              </td>
              <td
                style={{
                  height: "30px",
                  whiteSpace: "normal",
                  textAlign: "center",
                }}
              >
                {devices(item.devices)}
              </td>
              <td style={{ height: "30px", whiteSpace: "normal" }}>
                {cardLoads(item.bank_card_loads)}
              </td>
              <td style={{ height: "30px", whiteSpace: "normal" }}>
                {users(item.users)}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.total_spend / 100).toFixed(2)}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.lifetime_spend_users / 100).toFixed(2)}{" "}
              </td>
              <td style={{ textAlign: "right" }}>
                R{(item.average_tx / 100).toFixed(2)}{" "}
              </td>
              <td>{merchants(item.top_merchants)}</td>
            </tr>
          );
        });
      }
    };

    return (
      <section id="Fraud_LimitHits" className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <DatePicker
            hintText="Data of"
            onChange={this.changeDate}
            defaultDate={this.state.filter_date}
            style={{
              width: "200px",
              marginRight: "10px",
            }}
            textFieldStyle={{
              width: "200px",
            }}
          />
          <SelectField
            hintText="Status"
            value={null}
            onChange={this.handleGroupStatus}
            className={` ${
              this.state.selectedRows.length > 0 ? "shown" : "hidden"
            } `}
          >
            <MenuItem value={"monitored"} primaryText="Monitored" />
            <MenuItem value={"whitelisted"} primaryText="Whitelisted" />
            <MenuItem value={"blacklisted"} primaryText="Blacklisted" />
          </SelectField>
        </div>

        <div
          className={`loader-container ${
            this.state.loading ? "shown" : "hidden"
          }`}
        >
          <i className={`fa fa-spinner fa-spin fa-3x fa-fw`} />
        </div>

        <div
          id="setHeight"
          style={{ height: "calc(100% - 70px)", overflow: "auto" }}
        >
          <table
            style={{
              width: "100%",
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th style={{ paddingLeft: "2px" }}>
                  <input
                    type="checkbox"
                    className="itemSelectAll"
                    onClick={this.toggleAll}
                  />
                </th>
                <th style={{ textAlign: "center" }}>Devices</th>
                <th>Card loads</th>
                <th>Users</th>
                <th style={{ textAlign: "right" }}>Daily spend</th>
                <th style={{ textAlign: "right" }}>Lifetime spend</th>
                <th style={{ textAlign: "right" }}>Average Tx</th>
                <th>Top merchant</th>
              </tr>
            </thead>
            <tbody className={`${this.state.loading ? "hidden" : "shown"} `}>
              {showData()}
            </tbody>
          </table>
        </div>

        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={this.loadPrev}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          style={{ margin: "5px", padding: "4px" }}
          className={
            topDevicesList.length < 30 || this.state.loading ? "hidden" : ""
          }
          onClick={this.loadNext}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </section>
    );
  }
}

const suspiciousCardLoadsWithGraphql = graphql(susCardLoadsList, {
  options(props: any) {
    return {
      variables: {
        from: null,
        to: null,
        offset: OFFSET,
        limit: LIMIT,
      },
    };
  },
})(SuspiciousDevices);
export default suspiciousCardLoadsWithGraphql;
